import styled from 'styled-components';

const ViewPort = styled.main`
  padding-bottom: 3.125rem;
`;

export default ViewPort;
